import { render, staticRenderFns } from "./pullUpLoading.vue?vue&type=template&id=051274b0&scoped=true&"
import script from "./pullUpLoading.vue?vue&type=script&lang=ts&"
export * from "./pullUpLoading.vue?vue&type=script&lang=ts&"
import style0 from "./pullUpLoading.vue?vue&type=style&index=0&id=051274b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051274b0",
  null
  
)

export default component.exports